module.exports = __webpack_public_path__ + "img/PDAC1_DC.35e9ec2d.png";